import { urlRegExp } from 'schemas'
import yup from './yup'

export const sponsorFormSchema = ({ showSponsorshipLevel }) =>
  yup.object().shape({
    fullName: yup.string().label('Company').trimmedRequired('Company is required'),
    email: yup.string().email().label('Email').trimmedRequired('Email is required'),
    booth: yup.string().label('Booth No'),
    websiteUrl: yup
      .string()
      .matches(urlRegExp, 'Website URL must be a valid URL')
      .label('Website URL'),
    intro: yup.string().label('Introduction'),
    sponsorMessage: yup.string().label('Message'),
    sponsorshipLevelId: showSponsorshipLevel
      ? yup.string().label('Sponsorship level').trimmedRequired('Sponsorship level is required')
      : yup.string().label('Sponsorship level'),
    sponsorAdTargetURL: yup
      .string()
      .label('Banner Click URL')
      .matches(urlRegExp, 'Banner click URL must be a valid URL')
  })
